import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { FadeUp, SectionHead } from "./Reveal";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-24 lg:py-36 bg-forest-900/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <SectionHead
          num="08"
          eyebrow="Traveller Stories"
          title="Word From the Wild"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {TESTIMONIALS.map((t, i) => (
          <FadeUp key={t.name} delay={(i % 2) * 0.1}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="relative h-full p-8 lg:p-10 border border-gold/10 bg-forest-950/60 hover:border-gold/30 transition-colors duration-500"
            >
              <Quote size={26} className="text-gold/30 absolute top-7 right-8" strokeWidth={1} />
              <div className="flex gap-1 mb-6">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={13} className="fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="font-serif text-xl sm:text-2xl text-cream/90 leading-relaxed italic">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <span className="w-10 h-10 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center font-serif text-gold">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <span className="block text-sm text-cream">{t.name}</span>
                  <span className="block font-mono text-[10px] uppercase tracking-[0.18em] text-fog mt-1">
                    {t.place} · {t.tour}
                  </span>
                </div>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
